import { render, staticRenderFns } from "./OpenDaysAccordion.vue?vue&type=template&id=2b4e10ba&"
import script from "./OpenDaysAccordion.vue?vue&type=script&lang=js&"
export * from "./OpenDaysAccordion.vue?vue&type=script&lang=js&"
import style0 from "./OpenDaysAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports